import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import {Typography, Avatar, Grid, Stack, Box} from "@mui/material";

import withStyles from "@mui/styles/withStyles";
import defaultChatMsgStyles from "./defaultChatMsg.styles";
import Iconify from "../iconify";

const ChatMsg = withStyles(defaultChatMsgStyles, { name: "ChatMsg" }) (
    (props) => {
        const {
            classes,
            avatar,
            messages,
            side,
            GridContainerProps,
            GridItemProps,
            AvatarProps,
            getTypographyProps,
            date,
            onEdit,
            onDelete
        } = props;
        const attachClass = (index) => {
            if (index === 0) {
                return classes[`${side}First`];
            }
            if (index === messages.length - 1) {
                return classes[`${side}Last`];
            }
            return "";
        };
        return (
            <Stack direction="row" justifyContent={side === "right" ? "right" : "left"}>
                {side === "left" && (
                    <Avatar
                        src={avatar}
                        {...AvatarProps}
                        className={cx(classes.avatar, AvatarProps.className)}
                    />
                )}
                <Box sx={{marginX: 1}}>
                    {messages.map((msg, i) => {
                        const TypographyProps = getTypographyProps(msg.content, i, props);
                        return (
                            <div key={msg.id || i} className={classes[`${side}Row`]}>
                                {onEdit ? (
                                    <Typography
                                        sx={{cursor: 'pointer'}}
                                        // align={side}
                                        align='left'
                                        {...TypographyProps}
                                        className={cx(classes.msg, classes[side], attachClass(i), TypographyProps.className)}
                                        onClick={() => onEdit(msg.id)}
                                    >
                                        {msg.content}
                                    </Typography>
                                ) : (
                                    <Typography
                                        align='left'
                                        {...TypographyProps}
                                        className={cx(classes.msg, classes[side], attachClass(i), TypographyProps.className)}
                                    >
                                        {msg.content}
                                    </Typography>
                                )}
                            </div>
                        );
                    })}
                    <Typography sx={{marginLeft: 1, marginBottom: 1, fontSize: '10px'}}>
                        {date}
                        {onDelete && (
                            <>
                              - <Iconify icon={'eva:trash-2-outline'} width={10} sx={{position: 'relative', top: '1px', cursor: 'pointer'}} onClick={onDelete}/>
                            </>
                        )}
                    </Typography>
                </Box>
                {side === "right" && (
                    <Avatar
                        src={avatar}
                        {...AvatarProps}
                        className={cx(classes.avatar, AvatarProps.className)}
                    />
                )}
            </Stack>
        );
    }
);

ChatMsg.propTypes = {
    avatar: PropTypes.string,
    // messages: PropTypes.arrayOf(PropTypes.string),
    messages: PropTypes.arrayOf(PropTypes.shape({})),
    side: PropTypes.oneOf(["left", "right"]),
    GridContainerProps: PropTypes.shape({}),
    GridItemProps: PropTypes.shape({}),
    AvatarProps: PropTypes.shape({}),
    getTypographyProps: PropTypes.func,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func
};
ChatMsg.defaultProps = {
    avatar: "",
    messages: [],
    side: "left",
    GridContainerProps: {},
    GridItemProps: {},
    AvatarProps: {},
    getTypographyProps: () => ({})
};

export default ChatMsg;
